export default __webpack_public_path__ + "static/media/fsw_8.ed2f6c97.png";